var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutlineGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.5332 0.5H23.4814C26.1116 0.500091 28.0985 1.24382 29.4287 2.57715C30.7591 3.91085 31.5 5.90205 31.5 8.5332V23.4668C31.5 26.0979 30.7591 28.0891 29.4287 29.4229C28.0985 30.7562 26.1116 31.4999 23.4814 31.5H8.5332C5.90267 31.5 3.91106 30.7568 2.57715 29.4229C1.24323 28.0889 0.500014 26.0973 0.5 23.4668V8.5332C0.500024 5.90267 1.24324 3.91106 2.57715 2.57715C3.82776 1.32654 5.65653 0.595327 8.04785 0.508789L8.5332 0.5Z",
    stroke: "#010101"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34814_174354",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24C20.4183 24 24 20.4183 24 16C24 15.4116 23.9365 14.838 23.8159 14.2857H16V17.6H20.4054C19.7516 19.4 18.0259 20.6857 16 20.6857C13.4122 20.6857 11.3143 18.5878 11.3143 16C11.3143 13.4122 13.4122 11.3143 16 11.3143C17.3191 11.3143 18.5109 11.8593 19.3624 12.7365L21.6945 10.3811C20.2439 8.91109 18.2284 8 16 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5817 24 16 24Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34814_174354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.85938 16.0312L8.00223 11.6593L13.7165 16.1164L8.00223 20.345L2.85938 16.0312Z",
    fill: "#FEBD01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.6562L14.4571 5.19911L21.4286 7.71339L24.4571 13.0848L15.8286 13.4277L13.7143 16.1134L8 11.6562Z",
    fill: "#FF4131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6602 13.9473L24.9173 13.7188L24.803 17.833L22.5173 22.7473L17.8316 19.0902L15.6602 18.0616V13.9473Z",
    fill: "#0286F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20.3458L13.7143 16.1172L14.3429 18.9743L17.8286 19.0886L22.5143 22.7458L17.7714 24.8029L11.8857 24.46L8 20.3458Z",
    fill: "#01A94D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineGoogle);
export default __webpack_public_path__ + "static/media/outline-google.3d7d8a375e5d80181a17aab62a9db47d.svg";
export { ForwardRef as ReactComponent };